module.exports = __webpack_public_path__ + "dd3c12d3150d903df8e594dd1bcc5816.pdf";